import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { SolutionIntro } from './components/SolutionIntro';
import { HowItWorks } from './components/HowItWorks';
import { Gallery } from './components/Gallery';
import { UseCases } from './components/UseCases';
import { ShynessObjection } from './components/ShynessObjection';
import { WhatYouGet } from './components/WhatYouGet';
import { Purpose } from './components/Purpose';
import { Bonuses } from './components/Bonuses';
import { Reframe } from './components/Reframe';
import { Testimonials } from './components/Testimonials';
import { MissionTransition } from './components/MissionTransition';
import { FinalOffer } from './components/FinalOffer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3mjzpgvevclx2">
      <noscript data-id="element-1" data-mp="3rbrcivytg9ig">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3rdarmj8qkein" />
      </noscript>
      <SiteHeader data-id="element-3" data-mp="2zmwj72jhrued" />
      <main data-id="element-4" data-mp="2zng0ch1bierc">
        <Hero data-id="element-5" data-mp="33morde4z3yj7" />
        <Problem data-id="element-6" data-mp="33m5ck6amdq9e" />
        <SolutionIntro data-id="element-7" data-mp="33nq4do5juv3k" />
        <HowItWorks data-id="element-8" data-mp="33mymfg4vkvvr" />
        <Gallery data-id="element-9" data-mp="33oi1j3esp0vy" />
        <UseCases data-id="element-10" data-mp="38m1elzzrb7mb" />
        <ShynessObjection data-id="element-11" data-mp="38li7lebna3n2" />
        <WhatYouGet data-id="element-12" data-mp="38k6v8q44vnkc" />
        <Purpose data-id="element-13" data-mp="38nupxslbeg0n" />
        <Bonuses data-id="element-14" data-mp="3dkuvm2e95gr8" />
        <Reframe data-id="element-15" data-mp="3dle3sre3oqs2" />
        <Testimonials data-id="element-16" data-mp="3dlw4c07spr5s" />
        <MissionTransition data-id="element-17" data-mp="3dm5xtxs1ugg8" />
        <FinalOffer data-id="element-18" data-mp="nvj53kddcmru" />
        <Guarantee data-id="element-19" data-mp="nw2cw89b1us5" />
        <Faq data-id="element-20" data-mp="nuhiqjqwkdut" />
        <FinalClose data-id="element-21" data-mp="nv0ypuwzss67" />
      </main>
      <Footer data-id="element-22" data-mp="nxx0jubyo0zx" />
    </div>;
}